import * as React from "react";

const Icon = (props) =>  (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={11.241}
      height={11.238}
      {...props}
    >
      <path
        data-name="Path 113"
        d="M7.276 5.625l3.619-3.623A1.171 1.171 0 009.239.346L5.625 3.965 2.013.346A1.171 1.171 0 10.358 2.002l3.607 3.623L.346 9.239a1.164 1.164 0 000 1.656 1.171 1.171 0 001.656 0l3.623-3.619 3.6 3.607a1.171 1.171 0 001.656 0 1.164 1.164 0 000-1.656z"
        fill="#fff"
      />
    </svg>
  );


export default Icon;
